//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getRoom } from '@/api/room';
import util from "@/lib/util";

export default {
    name: "deliveryReceiveConfirmation",
    data() {
        return {
            leftIco: require('@/assets/img/ico-building.png'),
            roomInfo: {},
            deliverRecord: {},

            downloadUrl: util.ApiUrl + 'DocumentTransfer/ExportDeliveryDataPdf?roomId=',
            alreadySignPDFUrl: util.ApiUrl + 'DocumentTransfer/ExportAlreadySignPDF?roomId=',
            showSignPopup: false,
            options: {
                lastWriteSpeed: 1, //书写速度 [Number] 可选
                lastWriteWidth: 1, //下笔的宽度 [Number] 可选
                lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
                lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
                canvasWidth: 330, //canvas宽高 [Number] 可选
                canvasHeight: 150, //高度  [Number] 可选
                isShowBorder: false, //是否显示边框 [可选]
                bgColor: "#fcc", //背景色 [String] 可选
                borderWidth: 1, // 网格线宽度  [Number] 可选
                borderColor: "#ff787f", //网格颜色  [String] 可选
                writeWidth: 3, //基础轨迹宽度  [Number] 可选
                maxWriteWidth: 15, // 写字模式最大线宽  [Number] 可选
                minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
                writeColor: "#101010", // 轨迹颜色  [String] 可选
                isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
                imgType: "png" //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
            },
            saving: false,
            signImage: null
        }
    },
    methods: {
        getRecordById() {
            const vm = this;
            abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordById?id=' + this.recordId).then(res => {
                // vm.deliverRecord = {}
                vm.deliverRecord = res.data.result;
                if (vm.deliverRecord.content == null) {
                    vm.deliverRecord.content = '';
                }
                if (!vm.deliverRecord.visitorsNum) {
                    vm.deliverRecord.visitorsNum = '1人'
                }
                this.planId = vm.deliverRecord.planId;
                this.date = vm.deliverRecord.deliveryTimeStr;
                this.dateStr = this.date;
                this.time = vm.deliverRecord.time;
                this.timeStr = this.time;

                this.getRoom(vm.deliverRecord.roomId);

            });
        },

        getRoom(roomId) {
            getRoom(roomId).then(res => {
                this.roomInfo = {}
                this.roomInfo = res.data.result;
                // this.getDeliveryRecordByRoom();
            }).finally(() => {

            })
        },
        onDownLoadPdf() {
            let url = '';
            let timestamp = new Date().getTime();
            url = util.ApiUrl + 'DocumentTransfer/ExportDeliveryReceivePdf?recordId=' + this.recordId + '&time=' + timestamp.toString();
            window.open(url, '_blank')
        },

        onShowSignPopup() {
            this.showSignPopup = true;
        },

        onCanvasClear() {
            this.$refs.SignCanvas.canvasClear();
        },
        async saveAsImg() {
            if (!this.signImage) {
                this.$toast("请签名");
                return
            }
            const img = this.$refs.SignCanvas.saveAsImg();
            let file = this.base64toFile(img, "确认书" + this.recordId + '.png')
            let data = new FormData()
            data.append("file", file);
            data.append("associateType", 'DeliveryReceiveConfirmationSignature')
            this.saving = true;
            abp.ajax.post('/file/upload', data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
                const result = res.data.result;
                this.signSuccess(result);
            }).finally(() => {
                this.saving = false;
                this.showSignPopup = false;
            })
        },
        base64toFile(dataurl, filename) {
            let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        /*签名成功*/
        signSuccess(data) {
            let page = {
                recordId: this.recordId,
                signatureImage: {
                    associateId: this.roomId,
                    addAttrIds: [],
                    delAttrIds: [],
                    associateType: 'DeliveryReceiveConfirmationSignature',
                },
            }; 
            page.signatureImage.addAttrIds.push(data.id);
            abp.ajax.post('/api/services/app/DeliveryRecord/DeliveryReceiveConfirmation', page).then(res => {
                this.$toast('签名成功');
                this.showSignPopup = false;
                this.getRecordById();
            })
        },


    },
    created() {
        this.recordId = parseInt(this.$route.params.recordId) || 0;
        this.getRecordById();
    }
}
